module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_headphones-7eaaf043709d2adba8ef81c89f7555f2.svg";